import { Component, OnInit } from '@angular/core';
import { ApartmentTypesBaseComponent } from './../common-theme/index';

@Component({
  selector: 'app-houses',
  templateUrl: './houses.component.html',
  styleUrls: ['./houses.component.scss']
})

export class HousesComponent extends ApartmentTypesBaseComponent implements OnInit {
  ngOnInit(): void {
    super.ngOnInit();

    this.setTitle('Apartamentele din oferta Romanescu Park Residence');

    this.setMetaDescription(`
      Oferta Romanescu Park Residence cuprinde o gamă variată de apartamente, cu 2 și 3 camere.
      Indiferent de clădirea în care optezi să locuiești - Stejar, Frasin, Tei sa Arțar - , poți fi sigur că vei
      avea un cămin modern, spațios și confortabil.
    `);
  }
}



// WEBPACK FOOTER //
// ./src/app/houses/houses.component.ts